import { gsap } from 'gsap';
import Experience from './Experience';
import EventEmitter from './Utils/EventEmitter';

export default class Loader extends EventEmitter {
  constructor() {
    super();
    this.experience = new Experience();
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.loader = document.querySelector('.loader');
    this.debug = this.experience.debug;
    this.html = this.experience.html;

    this.minLoaderDuration = 3000;
    this.timeline = gsap.timeline({ repeat: -1, repeatDelay: 2.2 });

    this.setLoader();
    this.setAnimation();

    // if (this.debug.active) {
    //   this.loader.style.display = 'none';
    //   return;
    // }

    this.html.classList.add('loading');

    this.resources.on('ready', () => {
      if (this.time.elapsed < this.minLoaderDuration) {
        setTimeout(() => {
          this.hide();
        }, this.minLoaderDuration - this.time.elapsed);
      } else {
        this.hide();
      }
    });
  }

  setLoader() {
    this.loaderContainer = document.querySelector('.loader__inner');

    this.loaderContainer.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Layer_1" x="0" y="0" class="loader__logo" style="enable-background:new 0 0 270 270" version="1.1" viewBox="0 0 270 270"><style>.line{fill:none;stroke-miterlimit:10;stroke-width:3px;stroke:#bbb}</style><path d="m83.306 78.905-29.97-45.58c-3.19 2.5-6.25 5.15-9.19 7.93l18.82 28.41-30.2-16.19c-2.56 3.12-4.97 6.37-7.23 9.72l48.43 25.73a77.08 77.08 0 0 1 9.34-10.03v.01zM137.336 5.235c-4.03-.07-8.02.04-11.96.32l-13.13 56.99c3.96-1.21 8.06-2.12 12.27-2.68l1.12-4.87 1.07-4.89 12.44-.3 1.3 4.83 1.36 4.85c4.24.37 8.38 1.09 12.39 2.11l-15.85-56.33c-.34 0-.67-.03-1-.03h-.01zm-1.19 33.64-6.98.17 3.16-13.89 3.82 13.72zM183.146 76.025l18.88-19.34-10.64 26.98c3.04 3.26 5.79 6.79 8.23 10.53l38.49-39.44c-2.36-2.96-4.85-5.81-7.45-8.56l-20.16 20.66 11.44-29.03a132.35 132.35 0 0 0-9.74-7.75l-38.52 39.47c3.33 1.93 6.5 4.1 9.48 6.48h-.01zM209.382 116.438a75.286 75.286 0 0 1 2.352 20.175 76.286 76.286 0 0 1-.123 3.037l11.9 10.185 12.356-1.189 5.324-6.802 5.587 4.73 10.295-.991 9.2-11.667a128.963 128.963 0 0 0-2.233-22.74l-54.658 5.259v.003zm25.124 16.927-1.98 3.415-3.925 1.559-4.154-.78-2.615-2.973-.82-8.257 12.674-1.219.82 8.255zm21.274-2.361-1.718 2.838-3.224 1.334-3.429-.692-2.242-2.457-.79-7.947 10.612-1.023.787 7.947h.004zM204.233 167.984a75.4 75.4 0 0 1-6.332 10.74l2.861 4.121 2.904 4.092-8.212 9.248-4.469-2.328-4.527-2.299a76.637 76.637 0 0 1-9.97 7.578l52.583 26.678c.234-.237.473-.471.707-.712a131.874 131.874 0 0 0 7.871-8.918l-33.416-48.2zm1.37 33.442 4.608-5.192 8.17 11.718-12.778-6.526zM133.505 211.232a77.492 77.492 0 0 1-3.14-.125l-11.096 10.798.12 6.061 10.982-.211 1.1-3.987 3.171-2.315 4.08-.077 3.26 2.194 1.254 3.941.405 20.906-1.098 3.986-3.173 2.316-4.076.08-3.26-2.194-1.254-3.941-10.983.212.117 6.061 11.348 10.22c.415.013.827.032 1.241.039 3.805.07 7.57-.032 11.297-.276l10.943-10.65-.64-33.032-11.515-10.368c-2.98.292-6.01.42-9.08.366l-.003-.004zM87.156 194.765l-12.084 12.113 3.247-20.252a76.631 76.631 0 0 1-9.631-12.863l-5.217 34.5-33.326 5.378c2.7 3.528 5.58 6.908 8.623 10.144l23.439-4.006-13.494 13.524a130.313 130.313 0 0 0 9.003 7.097l39.07-39.163a77.256 77.256 0 0 1-9.627-6.466l-.003-.006z" class="letter"/><path class="number" d="M26.373 135.311v1.687h3.801v12.889h3.669v-18.129h-3.669l-3.8 3.553zm17.006 2.774h-2.987l-1.102.882.577-3.707h6.526v-3.502h-9.355l-1.232 8.585.788 1.453 3.013.545 1.076-.754h1.365l1.075.754.393 1.321v.648l-.393 1.321-1.075.754h-1.365l-1.076-.754-.392-1.321h-3.668v2.024l3.801 3.553h4.035l3.8-3.553v-4.695l-3.8-3.554h-.004z"/><g id="lines"><path d="m190.494 252.79-111-235.61M16.264 189.79l238.08-109.86M259.884 175.96c-9.26-.41-18.21-3.87-25.01-6.86l-2.93-1.3c-21.53-9.56-45.94-20.4-84.15-3.38-37.7 18.01-45 43.48-51.45 65.95-.29 1.03-.59 2.04-.88 3.05-2.05 7.08-5.13 16.08-10.76 23.37M182.934 14.28c-5.62 7.54-8.69 16.55-10.76 23.67-.29 1.01-.59 2.03-.88 3.06-6.28 21.9-13.39 46.72-49.9 64.16-37 16.48-60.79 5.92-81.77-3.4l-2.93-1.3c-6.84-3.01-15.79-6.47-25.24-7.06" class="line line-guide"/><path d="m190.494 252.79-111-235.61" class="line line-1"/><path d="m16.264 189.79 238.08-109.86" class="line line-2"/><path d="M259.884 175.96c-9.26-.41-18.21-3.87-25.01-6.86l-2.93-1.3c-21.53-9.56-45.94-20.4-84.15-3.38-37.7 18.01-45 43.48-51.45 65.95-.29 1.03-.59 2.04-.88 3.05-2.05 7.08-5.13 16.08-10.76 23.37" class="line line-3"/><path d="M182.934 14.28c-5.62 7.54-8.69 16.55-10.76 23.67-.29 1.01-.59 2.03-.88 3.06-6.28 21.9-13.39 46.72-49.9 64.16-37 16.48-60.79 5.92-81.77-3.4l-2.93-1.3c-6.84-3.01-15.79-6.47-25.24-7.06" class="line line-4"/></g></svg>
    `;
  }

  setAnimation() {
    const duration = this.minLoaderDuration / 1000;

    this.timeline
      .to('.loader__logo', {
        duration,
        rotation: -360,
        transformOrigin: 'center center',
      })

      .to(
        ['.line-1', '.line-2'],
        {
          duration,
          strokeDashoffset: 0,
          strokeDasharray: '265 265',
        },
        0,
      )
      .to(
        ['.line-3', '.line-4'],
        {
          duration: duration - 1,
          strokeDashoffset: 0,
          strokeDasharray: '240 240',
        },
        0.6,
      )

      .to(
        ['.letter', '.number'],
        {
          duration: 1.5,
          fill: '#BBBBBB',
          ease: 'power2.inOut',
        },
        duration - 2,
      );
  }

  hide() {
    // scroll to top
    window.scrollTo(0, 0);
    this.trigger('loaded');

    this.html.classList.remove('loading');
    this.loader.classList.add('hide');
    this.loader.addEventListener('animationend', () => {
      this.loader.style.display = 'none';
    });

    this.timeline.kill();
  }
}
